import { Capacitor } from "@capacitor/core";

// The one place the app decides "am I the wrapped native app or the browser
// PWA". Native builds have no dev proxy and load a bundled file:// shell, so
// their relative "/api/..." would resolve against the WebView origin — they
// must hit the live API origin explicitly. The web/PWA build keeps same-origin
// ("") so nginx serves /api next to the SPA exactly as today.
const LIVE_API_ORIGIN = "https://money.xynexglobal.com";

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function apiBase(): string {
  // Optional build-time override (e.g. staging) wins when set.
  const override = import.meta.env.VITE_API_BASE as string | undefined;
  if (override) return override.replace(/\/$/, "");
  return isNative() ? LIVE_API_ORIGIN : "";
}

/** Prefix a relative "/api/..." path with the resolved base. Absolute URLs pass through. */
export function resolveUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return apiBase() + path;
}
